import { render } from "./checkboxField.vue?vue&type=template&id=6559a4d4&ts=true"
import script from "./checkboxField.vue?vue&type=script&lang=ts"
export * from "./checkboxField.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__